import type { StudyMissionSelectDto } from '@@types/api.types';
import { TooltipComponent } from '@components/core/tooltip.component';
import { Button } from '@components/ui/button';
import type { FC } from 'react';
import { getMeiaMissionCode, getMeiaMissionName } from './meia-mission-display.util';

export const ALL_MISSIONS_FILTER_VALUE = 'all';

type MeiaMissionFilterPillsProps = {
  /** Optional per-mission count shown next to each mission code. */
  countByMissionId?: Map<string, number>;
  missions: StudyMissionSelectDto[];
  onSelect: (missionId: string) => void;
  /** Mission id or {@link ALL_MISSIONS_FILTER_VALUE}. */
  selectedMissionId: string;
  /** Optional count shown next to the All missions pill. */
  totalCount?: number;
};

/**
 * Compact mission filter chip strip for Effect-on-Target surfaces: an "All missions"
 * pill plus one short-code pill per mission (hover reveals the full mission name).
 */
export const MeiaMissionFilterPills: FC<MeiaMissionFilterPillsProps> = (props) => {
  const { countByMissionId, missions, onSelect, selectedMissionId, totalCount } = props;

  return (
    <div className="flex flex-wrap items-center gap-1.5">
      <Button
        onClick={() => onSelect(ALL_MISSIONS_FILTER_VALUE)}
        size="xs"
        type="button"
        variant={selectedMissionId === ALL_MISSIONS_FILTER_VALUE ? 'active' : 'outline'}
      >
        All missions{totalCount !== undefined && ` (${totalCount})`}
      </Button>
      {missions.map((mission, index) => {
        const count = countByMissionId?.get(mission.id);

        return (
          <TooltipComponent
            key={mission.id}
            trigger={
              <Button
                onClick={() => onSelect(mission.id)}
                size="xs"
                type="button"
                variant={selectedMissionId === mission.id ? 'active' : 'outline'}
              >
                {getMeiaMissionCode({ index, mission })}
                {count !== undefined && ` (${count})`}
              </Button>
            }
          >
            {getMeiaMissionName(mission)}
          </TooltipComponent>
        );
      })}
    </div>
  );
};
